import {StyleSheet, css} from 'aphrodite';
import React from 'react';

import {ComplexPolymerType} from 'modbio/complex-polymers/ComplexPolymerConstants';
import {
  AttachConjugateState,
  ConnectionSideType,
  SimplePolymer,
} from 'modbio/complex-polymers/tabs/ComplexPolymerAttachConjugateModalUtil';
import {ComponentRow} from 'modbio/complex-polymers/tabs/ComplexPolymerAttachConjugateSelectMenus';
import {
  ConjugateConnection,
  ConjugateConnectionMap,
} from 'modbio/complex-polymers/tabs/ComplexPolymerComponentsSummaryUtil';

interface LeavingGroupStyleAttachConjugateSectionProps {
  isEditMode: boolean;
  complexPolymerType: ComplexPolymerType;
  complexPolymerId?: string;
  conjugateConnectionMap: ConjugateConnectionMap;
  attachConjugateState: AttachConjugateState;
  forCreate: boolean;
  onClickAttach?: (conjugateConnection: ConjugateConnection) => void;
  currentConjugateConnection: ConjugateConnection;
  simplePolymers: Array<SimplePolymer>;
}

export default function LeavingGroupStyleAttachConjugateSection(
  props: LeavingGroupStyleAttachConjugateSectionProps
): JSX.Element {
  const {connection, updateConnection} = props.attachConjugateState;

  return (
    <div className={css(styles.wrapper)}>
      <ComponentRow
        {...props}
        connectionSideType={ConnectionSideType.TARGET}
        connection={connection}
        updateConnection={updateConnection}
      />
      <ComponentRow
        {...props}
        connectionSideType={ConnectionSideType.SOURCE}
        connection={connection}
        updateConnection={updateConnection}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
});
